module.exports = __webpack_public_path__ + "assets/img/main-logo-langfang.74a0a7b5.png";